import React, { createContext, useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import "./css/index.scss";
import { getFromIndexedDB, saveToIndexedDB } from "./utils/indexedDB";
import LoadingPage from "./Components/Loading";
import AppRouter from "./router/AppRouter";
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/js/bootstrap.js";
export const DataContext = createContext();

export default function App() {
  const dispatch = useDispatch();
  const { pages, proxy, socket } = useSelector((state) => state);
  const stringifiedUser = localStorage.getItem("user");
  const username = stringifiedUser ? JSON.parse(stringifiedUser) : "";
  // const url = window.location.pathname.split("/")[1];
  const url = window.location.pathname.replace(/^\/+/, "");

  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = useState();
  const [auth, setAuth] = useState();
  const _token = localStorage.getItem("_token");

  const buildPageMap = (pages) => {
    const map = {};

    const addToMap = (page) => {
      if (page.page_id) {
        map[page.page_id] = page;
      }
      if (Array.isArray(page.children)) {
        page.children.forEach(addToMap);
      }
    };

    pages.forEach(addToMap);
    return map;
  };

  const fetchAndSetPage = async (pages) => {
    const pageMap = buildPageMap(pages);
    const page = pageMap[url] || null;

    setPage(page);
    dispatch({
      type: "setCurrentPage",
      payload: { page },
    });
    dispatch({
      type: "setUIPages",
      payload: { pages },
    });
  };

  const fetchFreshData = async () => {
    const response = await fetch(proxy() + `/apis/get/ui?page=${url}`);
    const { success, data } = await response.json();

    if (success && data) {
      await saveToIndexedDB("pages", data);
      await fetchAndSetPage(data);
    }
  };

  useEffect(() => {
    const isTabOpened = sessionStorage.getItem("newTabOpened");

    if (!isTabOpened) {
      fetchFreshData();
      window.sessionStorage.setItem("newTabOpened", "true");
    }
  }, []);

  useEffect(() => {
    if (url.includes("check") || url.includes("logs")) {
      setLoading(false);
      return;
    }

    const FetchUis = async () => {
      const cachedPages = await getFromIndexedDB("pages");

      if (cachedPages && cachedPages.length > 0) {
        await fetchAndSetPage(cachedPages);
      } else {
        const response = await fetch(proxy() + `/apis/get/ui?page=${url}`);
        const { success, data } = await response.json();

        if (success && data) {
          await saveToIndexedDB("pages", data);
          await fetchAndSetPage(data);
        }
      }
      setLoading(false);
    };

    const handleUIUpdate = async () => {
      await saveToIndexedDB("pages", []);
      await fetchFreshData();
    };

    socket.on("/dipe-production-import-ui", handleUIUpdate);

    FetchUis();

    // const intervalId = setInterval(() => {
    //   if (!url.includes("check") && !url.includes("logs")) {
    //     fetchFreshData();
    //   }
    // }, 300000);

    dispatch({
      type: "changeSocketURL",
      payload: proxy(),
    });

    return () => {
      // clearInterval(intervalId);
      socket.off("/dipe-production-import-ui", handleUIUpdate);
    };
  }, [url]);

  useEffect(() => {
    if (url.includes("check") || url.includes("logs")) {
      return null;
    }
    if (username) {
      const fetchUser = async () => {
        const response = await fetch(`${proxy()}/auth/v2/u/${username}`, {
          headers: {
            Authorization: _token,
          },
        });
        const { user } = await response.json();
        setAuth(user);

        if (user) {
          dispatch({
            branch: "default",
            type: "setAuthInfor",
            payload: {
              user,
            },
          });
        }
      };
      fetchUser();
    }
  }, [username]);

  const [dataNhapXuatTon, setDataNhapXuatTon] = useState([]);
  const [isLoadingNhapXuatTon, setIsLoadingNhapXuatTon] = useState(true);

  useEffect(async () => {
    if (url.includes("check") || url.includes("logs")) {
      return null;
    }
    try {
      const res = await fetch(proxy() + "/api/stats/Kho/SoLot", {
        method: "POST",
        headers: {
          Authorization: _token,
        },
      });

      if (!res.ok) {
        throw new Error("Failed to fetch");
      }
      const data = await res.json();
      setDataNhapXuatTon(data);
    } catch (err) {
      console.error("Loader error:", err);
      // Optional: redirect or return fallback
      throw err;
    } finally {
      setIsLoadingNhapXuatTon(false);
    }
  }, []);

  // useEffect(() => {
  //   if (url.includes("check") || url.includes("logs")) {
  //     return;
  //   }
  //   const fetchPage = async () => {
  //     try {
  //       const response = await fetch(`${proxy()}/apis/get/ui?page=${url}`);
  //       const { data } = await response.json();
  //       setLoading(true)
  //       if (data) {
  //         setPage(data);
  //         dispatch({
  //           type: "setCurrentPage",
  //           payload: { data },
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };

  //   fetchPage();
  // }, [url]);

  const router = AppRouter({
    pages,
    auth,
    url,
    page,
  });

  return isLoading ? (
    <LoadingPage />
  ) : (
    // <PageNotFound />
    <DataContext.Provider
      value={{ dataNhapXuatTon, isLoadingNhapXuatTon, page }}
    >
      <RouterProvider router={router} />
    </DataContext.Provider>
  );
}
